<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="angecy-app-container" style="position: relative; height: 100%; padding: 15px">
    <data-table />
  </div>
</template>

<script>
export default {
  name: 'AppManageAgency',
  components: {
    dataTable: () => import('@/views/ita/appManage/components/agencyDataTable.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
